import Modal from '@mui/material/Modal';
import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
// import Modal from '@mui/material/Modal';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};
export default function PythonProgMod() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      <Button onClick={handleOpen} style={{color:'teal'}}>Python Programming</Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        
      >
        <Box sx={style} height={300} width={300} style={{'background':'aquamarine'}}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Introduction to Programming
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            Python Programming<br/>
            1:- Program is set of instructions which gives desired out if data proccessed correctly.<br/>
            2:- Program contains two parts operand and Operators<br/>
            3:- Programs are converted to mnemonics or machine language so that machine can understand.<br/>
            4:- There is a linker and loader to load and execute the program.<br/>
            5:- The output is an executable file 
          </Typography>
        </Box>
      </Modal>
    </div>
  );
}